"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getStartAndEndTimestamps = exports.toDatePickerFormat2 = exports.toDatePickerFormat = exports.getHumanReadableMinSecs = exports.getHumanReadableTimeSince = exports.getTTLSeconds = exports.getNiceTimeRange = exports.getNiceTimeOnly = exports.getNiceDateOnly = exports.getNiceTime = exports.getNiceDates = exports.getGoogleDate = exports.getNiceDate = exports.getHumanReadableDate = exports.logHumanReadableDate = exports.getTimezoneOffsetFromUTC = exports.isYearRollover = exports.isMonthRollover = exports.isWeekRollover = exports.isDayRollover = exports.isHourRollover = exports.getTZOffsetDate = exports.getTimePeriodNumber = exports.getTimePeriodString = exports.getLast24HourSlice = exports.timestampToMS = exports.nothingYet = void 0;
exports.getTimePeriod = getTimePeriod;
const tslib_1 = require("tslib");
const config_1 = tslib_1.__importDefault(require("@iotv/config"));
const core_services_1 = require("@iotv/core-services");
const iotv_v3_types_1 = require("@iotv/iotv-v3-types");
const constants_1 = require("../../constants");
const debug = process.env.REACT_APP_DEBUG && false;
exports.nothingYet = true;
const timestampToMS = (ts) => {
    let tsms = undefined;
    if (typeof ts === 'number') {
        tsms = ts > 9999999999 ? ts : ts * 1000;
    }
    else if (typeof ts === 'string') {
        const tsnum = parseInt(ts);
        tsms = tsnum > 9999999999 ? tsnum : tsnum * 1000;
    }
    return tsms;
};
exports.timestampToMS = timestampToMS;
const getLast24HourSlice = (tzOffset, pastStates) => {
    const days = 1;
    const daysFromNow = -1;
    const period = (0, exports.getTimePeriodNumber)(tzOffset, daysFromNow, days, iotv_v3_types_1.AppValueTypes.TIMESTAMP_SEC);
    const tssSlice = pastStates.filter((tss) => tss.timestamp >= period.start && tss.timestamp < period.end);
    return tssSlice;
};
exports.getLast24HourSlice = getLast24HourSlice;
function getTimePeriod(tzOffset, daysFromNow, numberOfDays, outputTimestampType, outputTimestampFormat, nowMs) {
    let dayStart = nowMs ? new Date(nowMs) : new Date();
    dayStart.setUTCHours(tzOffset, 0, 0, 0);
    dayStart.setUTCDate(dayStart.getUTCDate() + daysFromNow);
    let dayEnd = new Date(dayStart).setUTCDate(dayStart.getUTCDate() + numberOfDays);
    const msTimestamp = { start: dayStart.valueOf(), end: dayEnd.valueOf() };
    const secTimestamp = { start: msTimestamp.start / 1000, end: msTimestamp.end / 1000 };
    if (outputTimestampFormat === iotv_v3_types_1.AppValueTypes.TIMESTAMP_SEC || outputTimestampFormat === iotv_v3_types_1.AppValueTypes.TIMESTAMP_STRING_SEC) {
        if (outputTimestampType === iotv_v3_types_1.TimestampType.NUMBER) {
            return secTimestamp;
        }
        else {
            return { start: secTimestamp.start.toString(), end: secTimestamp.end.toString() };
        }
    }
    else {
        if (outputTimestampType === iotv_v3_types_1.TimestampType.NUMBER) {
            return msTimestamp;
        }
        else {
            return { start: msTimestamp.start.toString(), end: msTimestamp.end.toString() };
        }
    }
}
const getTimePeriodString = (tzOffset, daysFromNow, numberOfDays, outputTimestampFormat) => getTimePeriod(tzOffset, daysFromNow, numberOfDays, iotv_v3_types_1.TimestampType.STRING, outputTimestampFormat);
exports.getTimePeriodString = getTimePeriodString;
const getTimePeriodNumber = (tzOffset, daysFromNow, numberOfDays, outputTimestampFormat) => getTimePeriod(tzOffset, daysFromNow, numberOfDays, iotv_v3_types_1.TimestampType.NUMBER, outputTimestampFormat);
exports.getTimePeriodNumber = getTimePeriodNumber;
const getTZOffsetDate = (timestampMS, tzOffset) => {
    let dateAtTZ = new Date(timestampMS);
    dateAtTZ.setUTCHours(dateAtTZ.getUTCHours() + tzOffset);
    return dateAtTZ;
};
exports.getTZOffsetDate = getTZOffsetDate;
/*
  Rollver Fns: rollover of M/D/Y *** in the TZ with the tzOffset *** between UTC timestamps at those UTC times

  Each isRollover Fn requires the tzOffset to be the negative of the local tzOffset eg NZ is UTC + 12, so the following works in
  both Lambda ( TZ 0 ) and locally in say NZ ( TZ +12 )
  const tzOffset = (new Date().getTimezoneOffset()

  Lambda tzOffset = 0
  NZ tzOffset = -12

  Note: decision is NOT to account for daylight saving in Lambdas so a 'mignight' process would occur at 00:00 NZ time in winter and 01:00 NZ time in summer
  */
const isHourRollover = (previousTimestampMS, currentTimestampMS, tzOffset) => {
    const prvDateTZ = (0, exports.getTZOffsetDate)(previousTimestampMS, tzOffset);
    const currDateTZ = (0, exports.getTZOffsetDate)(currentTimestampMS, tzOffset);
    // const hourDiff = prvDateTZ.getUTCHours() - currDateTZ.getUTCHours()
    // const dateDiff = prvDateTZ.getUTCDate() - currDateTZ.getUTCDate()
    // const monthDiff = prvDateTZ.getUTCMonth() - currDateTZ.getUTCMonth()
    // const yearDiff = prvDateTZ.getUTCFullYear() - currDateTZ.getUTCFullYear()
    return (previousTimestampMS < currentTimestampMS &&
        (prvDateTZ.getUTCHours() !== currDateTZ.getUTCHours() ||
            prvDateTZ.getUTCDate() !== currDateTZ.getUTCDate() ||
            prvDateTZ.getUTCMonth() !== currDateTZ.getUTCMonth() ||
            prvDateTZ.getUTCFullYear() !== currDateTZ.getUTCFullYear()));
};
exports.isHourRollover = isHourRollover;
const isDayRollover = (previousTimestampMS, currentTimestampMS, tzOffset) => {
    const prvDateTZ = (0, exports.getTZOffsetDate)(previousTimestampMS, tzOffset);
    const currDateTZ = (0, exports.getTZOffsetDate)(currentTimestampMS, tzOffset);
    const dateDiff = prvDateTZ.getUTCDate() - currDateTZ.getUTCDate();
    const monthDiff = prvDateTZ.getUTCMonth() - currDateTZ.getUTCMonth();
    const yearDiff = prvDateTZ.getUTCFullYear() - currDateTZ.getUTCFullYear();
    return previousTimestampMS < currentTimestampMS && ((dateDiff < 0 && monthDiff === 0 && yearDiff === 0) || (monthDiff < 0 && yearDiff === 0) || yearDiff < 0);
};
exports.isDayRollover = isDayRollover;
/**
 * Day rolls over when it has been 7 (or more) days, or to reset on mondays
 * @link https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date/getDay
 */
const isWeekRollover = (previousTimestampMS, currentTimestampMS, tzOffset) => {
    const msDifference = currentTimestampMS - previousTimestampMS;
    if (msDifference < 0) {
        return false;
    }
    const dayDifference = Math.floor(msDifference / constants_1.Milliseconds.DAY);
    // roll over starts only on mondays (?)
    const prvDateTZ = (0, exports.getTZOffsetDate)(previousTimestampMS, tzOffset);
    const currDateTZ = (0, exports.getTZOffsetDate)(currentTimestampMS, tzOffset);
    const dateDiff = prvDateTZ.getUTCDate() - currDateTZ.getUTCDate();
    const dayOfWeek = currDateTZ.getDay();
    const isMonday = dayOfWeek === 1;
    return dayDifference >= 7 || (isMonday && dateDiff > 0); // might not even need dayDifference
};
exports.isWeekRollover = isWeekRollover;
const isMonthRollover = (previousTimestampMS, currentTimestampMS, tzOffset) => {
    const prvDateTZ = (0, exports.getTZOffsetDate)(previousTimestampMS, tzOffset);
    const currDateTZ = (0, exports.getTZOffsetDate)(currentTimestampMS, tzOffset);
    const monthDiff = prvDateTZ.getUTCMonth() - currDateTZ.getUTCMonth();
    const yearDiff = prvDateTZ.getUTCFullYear() - currDateTZ.getUTCFullYear();
    return previousTimestampMS < currentTimestampMS && ((monthDiff < 0 && yearDiff === 0) || yearDiff < 0);
};
exports.isMonthRollover = isMonthRollover;
const isYearRollover = (previousTimestampMS, currentTimestampMS, tzOffset) => {
    const prvDateTZ = (0, exports.getTZOffsetDate)(previousTimestampMS, tzOffset);
    const currDateTZ = (0, exports.getTZOffsetDate)(currentTimestampMS, tzOffset);
    const yearDiff = prvDateTZ.getUTCFullYear() - currDateTZ.getUTCFullYear();
    return previousTimestampMS < currentTimestampMS && yearDiff < 0;
};
exports.isYearRollover = isYearRollover;
/** Gets the timezome offset relative to UTC
 * Negated because getTimezoneOffset() returns the offset from local time To UTC
 * e.g NZT gives -12 (or -13) because UTC is 12 (or 13) hours behind
 * But we usually want the offset from UTC e.g. NZT is UTC+12 (or 13) so give us +12 (or 13)
 * @returns Timezone offset from UTC in Milliseconds
 */
const getTimezoneOffsetFromUTC = () => {
    return new Date().getTimezoneOffset() * -constants_1.Milliseconds.MINUTE;
};
exports.getTimezoneOffsetFromUTC = getTimezoneOffsetFromUTC;
const logHumanReadableDate = (timestampMs) => {
    debug && console.log((0, exports.getHumanReadableDate)(timestampMs));
};
exports.logHumanReadableDate = logHumanReadableDate;
const getHumanReadableDate = (timestampMs) => {
    const date = new Date(timestampMs);
    return `${date.getDay()} : ${date.getDate()} : ${date.getMonth()} : ${date.getFullYear()}  `;
};
exports.getHumanReadableDate = getHumanReadableDate;
const getNiceDate = (timestamp, format = { weekday: 'short', day: 'numeric', month: 'short' }) => {
    let timestampNum = typeof timestamp === 'string' ? parseInt(timestamp) : timestamp;
    let timestampMsSecs = timestampNum < 9999999999 ? timestampNum * 1000 : timestampNum;
    const datetime = new Date(timestampMsSecs);
    const nowString = new Date().toLocaleDateString(config_1.default.locale, format);
    const thenStrting = datetime.toLocaleDateString(config_1.default.locale, format);
    const isToday = nowString === thenStrting;
    const dateSt = format.weekday !== 'short' && isToday ? 'Today' : thenStrting;
    const timeSt = datetime.toLocaleTimeString(config_1.default.locale, { hour: 'numeric', minute: 'numeric' });
    return `${dateSt} ${timeSt}`.replace(',', '');
};
exports.getNiceDate = getNiceDate;
const getGoogleDate = (timestamp) => {
    let timestampNum = typeof timestamp === 'string' ? parseInt(timestamp) : timestamp;
    const date = new Date(timestampNum);
    const localTime = `${date.toLocaleDateString()} ${date.toLocaleTimeString()}`;
    return localTime;
};
exports.getGoogleDate = getGoogleDate;
const getNiceDates = (timestamps) => {
    return timestamps.map((ts) => (0, exports.getNiceDate)(ts));
};
exports.getNiceDates = getNiceDates;
const getNiceTime = (timestamp, format = { weekday: 'short', day: 'numeric', month: 'short' }) => {
    let timestampNum = typeof timestamp === 'string' ? parseInt(timestamp) : timestamp;
    let timestampMsSecs = timestampNum < 9999999999 ? timestampNum * 1000 : timestampNum;
    const datetime = new Date(timestampMsSecs);
    const nowString = new Date().toLocaleDateString(config_1.default.locale, format);
    const thenStrting = datetime.toLocaleDateString(config_1.default.locale, format);
    const isToday = nowString === thenStrting;
    const dateSt = format.weekday !== 'short' && isToday ? 'Today' : thenStrting;
    const timeSt = datetime.toLocaleTimeString(config_1.default.locale, { hour: 'numeric', minute: 'numeric', second: 'numeric' });
    return `${dateSt} ${timeSt}`.replace(',', '');
};
exports.getNiceTime = getNiceTime;
const getNiceDateOnly = (timestamp, format = { weekday: 'short', day: 'numeric', month: 'short' }) => {
    let timestampNum = typeof timestamp === 'string' ? parseInt(timestamp) : timestamp;
    let timestampMsSecs = timestampNum < 9999999999 ? timestampNum * 1000 : timestampNum;
    const datetime = new Date(timestampMsSecs);
    const nowString = new Date().toLocaleDateString(config_1.default.locale, format);
    const thenStrting = datetime.toLocaleDateString(config_1.default.locale, format);
    const isToday = nowString === thenStrting;
    const dateSt = format.weekday !== 'short' && isToday ? 'Today' : thenStrting;
    return dateSt;
};
exports.getNiceDateOnly = getNiceDateOnly;
const getNiceTimeOnly = (timestamp, format = { hour: 'numeric', minute: 'numeric' }) => {
    let timestampNum = typeof timestamp === 'string' ? parseInt(timestamp) : timestamp;
    let timestampMsSecs = timestampNum < 9999999999 ? timestampNum * 1000 : timestampNum;
    const datetime = new Date(timestampMsSecs);
    return `${datetime.toLocaleTimeString(config_1.default.locale, format)}`;
};
exports.getNiceTimeOnly = getNiceTimeOnly;
/** Gets a time range where the day is displayed only if the timestamp goes into the next day
 * @example - Monday 1pm to Monday 2pm = Monday 1pm - 2pm
 * @example - Monday 1pm to Tuesday 3pm = Monday 1pm - Tuesday 3pm
 * */
const getNiceTimeRange = (fromTs, toTs) => {
    const fromDate = (0, exports.getNiceDateOnly)(fromTs);
    const toDate = (0, exports.getNiceDateOnly)(toTs);
    return `${(0, exports.getNiceDate)(fromTs)} - ${fromDate === toDate ? (0, exports.getNiceTimeOnly)(toTs) : (0, exports.getNiceDate)(toTs)}`;
};
exports.getNiceTimeRange = getNiceTimeRange;
/** gets epoch time in seconds based on number of days from now */
const getTTLSeconds = (daysFromNow) => {
    const now = new Date();
    const ttl = Math.ceil(now.setDate(now.getDate() + daysFromNow) / 1000);
    return ttl;
};
exports.getTTLSeconds = getTTLSeconds;
const getHumanReadableTimeSince = (thenSeconds, nowishSeconds) => {
    thenSeconds = Math.round(thenSeconds);
    nowishSeconds = Math.round(nowishSeconds);
    const secondsDifference = Math.round(nowishSeconds - thenSeconds);
    let lazyHumanTimeDifferenceStr = `${secondsDifference} ${(0, core_services_1.pluralize)('second', secondsDifference)}`;
    const minutesDiff = Math.round(secondsDifference / 60);
    const hourDiff = Math.round(minutesDiff / 60);
    const dayDiff = Math.round(hourDiff / 24);
    if (minutesDiff >= 1) {
        if (hourDiff >= 1) {
            if (dayDiff >= 1) {
                lazyHumanTimeDifferenceStr = `${dayDiff} ${(0, core_services_1.pluralize)('day', dayDiff)}`;
            }
            else {
                lazyHumanTimeDifferenceStr = `${hourDiff} ${(0, core_services_1.pluralize)('hour', hourDiff)}`;
            }
        }
        else {
            lazyHumanTimeDifferenceStr = `${minutesDiff} ${(0, core_services_1.pluralize)('minute', minutesDiff)}`;
        }
    }
    debug && console.log({ secondsDifference, minutesDiff, hourDiff, dayDiff, awolSinceMessage: lazyHumanTimeDifferenceStr });
    return lazyHumanTimeDifferenceStr;
};
exports.getHumanReadableTimeSince = getHumanReadableTimeSince;
const getHumanReadableMinSecs = (durationMs) => {
    const mins = Math.floor(durationMs / constants_1.Milliseconds.MINUTE);
    const secs = Math.round((durationMs % constants_1.Milliseconds.MINUTE) / constants_1.Milliseconds.SECOND);
    return `${mins} min ${secs} sec`;
};
exports.getHumanReadableMinSecs = getHumanReadableMinSecs;
const toDatePickerFormat = (timestampMs) => {
    let s = '';
    try {
        const iso = new Date(timestampMs).toISOString();
        const firstSep = iso.indexOf(':');
        const cutIdx = firstSep + 3;
        s = iso.substring(0, cutIdx);
    }
    catch (e) {
        s = e.message;
    }
    return s;
};
exports.toDatePickerFormat = toDatePickerFormat;
const toDatePickerFormat2 = (timestampMs) => {
    let s = '';
    try {
        const iso = new Date(timestampMs).toISOString();
        s = iso.split('T')[0];
    }
    catch (e) {
        s = e.message;
    }
    return s;
};
exports.toDatePickerFormat2 = toDatePickerFormat2;
// WARNING AXJ origin
const getStartAndEndTimestamps = (previousTimestampMS, currentTimestampMS, tzOffset, yearlyOrMonthly) => {
    //yearlyOrMonthly-monthly=0,yearly=1
    const prvDateTZ = (0, exports.getTZOffsetDate)(previousTimestampMS, tzOffset);
    const currDateTZ = (0, exports.getTZOffsetDate)(currentTimestampMS, tzOffset);
    if ((yearlyOrMonthly = 0)) {
        const firstDay = new Date(prvDateTZ.getUTCFullYear(), prvDateTZ.getUTCMonth(), 1);
        const msTimestamp = { start: firstDay.valueOf(), end: prvDateTZ.valueOf() };
        return msTimestamp;
    }
    else if (yearlyOrMonthly == 1) {
        const firstDay = new Date(prvDateTZ.getUTCFullYear(), 0, 1);
        const msTimestamp = { start: firstDay.valueOf(), end: prvDateTZ.valueOf() };
        return msTimestamp;
    }
};
exports.getStartAndEndTimestamps = getStartAndEndTimestamps;
